import React from "react";
import CSSModules from "react-css-modules";
import styles from "./transactions.scss";
import PropTypes from "prop-types";
import moment from "moment";
import NumberFormatter from "../../../utils/numberFormatter";

@CSSModules(styles)
class TransactionsList extends React.Component {
  static propTypes = {
    transactions: PropTypes.array,
    title: PropTypes.string,
  };

  render() {
    return (
      <div className={styles.transactions}>
        {(!this.props.transactions || !this.props.transactions.length) && (
          <div styleName="activity" data-at={`No-activity-to-display-${this.props.title}`}>No activity to display</div>
        )}
        {this.props.transactions && this.props.transactions.map((transaction, index, transactions) => {
          const isAmountPositive =
            transaction.aggregateTransactionAmount < 0 ? false : true;
          let rowClass = "transaction-row";
          if (transactions.length - 1 === index) {
            rowClass += "-last";
          }
          if (!isAmountPositive) {
            rowClass += "--green";
          }
          return (
            <div
              key={index}
              className={styles[rowClass]}
              data-at="transaction-row"
            >
              <div className={styles["transaction-row-left"]}>
                <div className={styles["item"]}>
                  <span data-at="transaction-date">
                    {transaction.transactionDate ? moment(transaction.transactionDate).format("MM/DD/YYYY") : ''}
                  </span>
                </div>
                <div>
                  <span data-at="merchant-description">
                    {transaction.merchantDescription}
                  </span>
                </div>
              </div>
              <div className={styles["transaction-row-right"]}>
                <div>
                  <span
                    className={styles.bold}
                    data-at="aggregate-transaction-amount"
                  >
                    {NumberFormatter.getCurrencyFormattedNumber(
                      transaction.aggregateTransactionAmount
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default TransactionsList;



// WEBPACK FOOTER //
// ./src/card/transaction/transactionsList/transactionsList.js